import React, { Component } from 'react'
import { observer } from 'mobx-react'
import { Button, ButtonGroup, OverlayTrigger, Popover } from 'react-bootstrap'
import { Link } from 'react-router'

import CreatePackingSlipModal from './createpackingslipmodal'
import PaymentDetailsModal from './paymentdetailsmodal'
import ProcessPaymentsModal from './processpaymentsmodal'
import TrackingNumberModal from './trackingnumbermodal'

@observer(['globals', 'companies', 'contacts', 'quickbooks', 'invoices'])
export default class Progress extends Component {

  constructor(props) {
    super(props)

    this.state = {
      showCreatePackingSlipModal: false,
      showProcessPaymentModal: false,
      showPaymentDetailModal: false,
      showTrackingNumberModal: false
    }
  }

  reload(callback) {
    this.props.reload(() => {
      if (callback != null) {
        callback()
      }
    })
  }

  setLoadableState(loadableState) {
    this.props.setLoadableState(loadableState)
  }

  //Modal State Management
  openProcessPaymentModal(row) {
    this.setState({
      invoiceToken: row.token,
      showProcessPaymentModal: true
    })
  }

  closeProcessPaymentModal() {
    this.setState({
      showProcessPaymentModal: false
    })
  }

  openPaymentDetailModal(row) {
    this.setState({
      showPaymentDetailModal: true,
      activeRow: row
    })
  }

  closePaymentDetailModal() {
    this.setState({
      showPaymentDetailModal: false,
      activeRow: {}
    })
  }

  openCreatePackingSlipModal(row) {
    this.setState({
      showCreatePackingSlipModal: true
    })
  }

  closeCreatePackingSlipModal() {
    this.setState({
      showCreatePackingSlipModal: false
    })
  }

  openTrackingNumberModal(row) {
    this.setState({
      showTrackingNumberModal: true
    })
  }

  closeTrackingNumberModal() {
    this.setState({
      showTrackingNumberModal: false
    })
  }

  render() {
    const popover = (
      <Popover id="popover-basic" title="Error!">
        This order was manually pushed to QB.  Payment cannot be processed via the CRM and must be processed directly in QB!
      </Popover>
    );

    //Payment Buttons Creation
    let paymentButton = <Button bsSize="small" bsStyle="inactive" onClick={() => { this.openProcessPaymentModal(this.props.row) }}><i className="fa fa-pencil-square-o" aria-hidden="true"></i> Payment </Button>

    if (this.props.row.paymentId !== null) {
      paymentButton = <Button bsSize="small" bsStyle="payment" onClick={() => { this.openPaymentDetailModal(this.props.row) }}><i className="fa fa-pencil-square-o" aria-hidden="true"></i> Payment </Button>
    }
    else if (this.props.row.qbOrderNumber != null && this.props.row.paymentId === null) {
      paymentButton = <OverlayTrigger trigger="click" placement="right" overlay={ popover }><Button bsSize="small" bsStyle="inactive"><i className="fa fa-pencil-square-o" aria-hidden="true"></i> Payment </Button></OverlayTrigger>
    }
    /*
    else if (this.props.row.paymentId === null) {
      paymentButton = <Button bsSize="small" bsStyle="inactive" disabled onClick={() => { this.openProcessPaymentModal(this.props.row) }}><i className="fa fa-pencil-square-o" aria-hidden="true"></i> Payment </Button>
    }
    */

    //Packing Slip Button Creation
    let packingSlipButton = <Button bsSize="small" bsStyle="inactive" onClick={() => { this.openCreatePackingSlipModal(this.props.row) }}><i className="fa fa-pencil-square-o" aria-hidden="true"></i> Packing Slip </Button>

    if (this.props.row.serialNumbers != null) {
      packingSlipButton = <Button bsSize="small" bsStyle="packingSlip" onClick={() => { this.openCreatePackingSlipModal(this.props.row) }}><i className="fa fa-pencil-square-o" aria-hidden="true"></i> Packing Slip </Button>
    }

    //Tracking Number Button Creation
    let trackingNumberButton = <Button bsSize="small" bsStyle="inactive" onClick={() => { this.openTrackingNumberModal(this.props.row) }}><i className="fa fa-pencil-square-o" aria-hidden="true"></i> Tracking Number </Button>

    if (this.props.row.trackingNumber != null) {
      let urlPath = 'https://google.com/search?q=' + this.props.row.trackingNumber
      trackingNumberButton = <Button bsSize="small" bsStyle="tracking"><i className="fa fa-pencil-square-o" aria-hidden="true"></i><a href={urlPath} target="_blank" style={{ color: "white" }}> Tracking Number </a></Button>
      //trackingNumberButton = <Button bsSize="small" bsStyle="tracking" onClick={() => { this.openTrackingNumberModal(this.props.row) }}><i className="fa fa-pencil-square-o" aria-hidden="true"></i> Tracking Number </Button>
    }

    return (
      <div>
        <ButtonGroup>
          {paymentButton}
          {packingSlipButton}
          {trackingNumberButton}
        </ButtonGroup>
        {
          this.state.showPaymentDetailModal
            ? <PaymentDetailsModal open={true} paymentId={this.props.row.paymentId} onClose={this.closePaymentDetailModal.bind(this)} />
            : ''
        }
        {
          this.state.showProcessPaymentModal
            ? <ProcessPaymentsModal open={true} invoiceToken={this.props.row.token} onClose={this.closeProcessPaymentModal.bind(this)} reload={this.reload.bind(this)} setLoadableState={this.setLoadableState.bind(this)} />
            : ''
        }
        {
          this.state.showCreatePackingSlipModal
            ? <CreatePackingSlipModal open={true} invoiceId={this.props.row.id} onClose={this.closeCreatePackingSlipModal.bind(this)} />
            : ''
        }
        {
          this.state.showTrackingNumberModal
            ? <TrackingNumberModal open={true} invoiceId={this.props.row.id} onClose={this.closeTrackingNumberModal.bind(this)} reload={this.reload.bind(this)} setLoadableState={this.setLoadableState.bind(this)} />
            : ''
        }
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/invoices/progress.js